module.exports = __webpack_public_path__ + "static/mobile-install-farms-3a875f3e15dea85cf02a781457b12540.gif";